query StorageBreakdown(
  $page: Int
  $rowsPerPage: Int
  $sort: StorageBreakdownSort
  $onlyUnwatched: Boolean
) {
  storageBreakdown(
    page: $page
    rowsPerPage: $rowsPerPage
    sort: $sort
    onlyUnwatched: $onlyUnwatched
  ) {
    items {
      contentId
      title
      createdAt
      durationSeconds
      storageMinutes
      storageBytes
      estimated
      storageCostUsdMonth
      viewsLast90Days
      watchedMinutesLast90Days
      onSale
      hasPurchases
    }
    totalCount
    totals {
      contentsCount
      durationSeconds
      storageMinutes
      storageBytes
      storageCostUsdMonth
      unwatchedCount
      unwatchedCostUsdMonth
    }
  }
}
